import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem;
	border: 1px solid #ddd;
	border-radius: 0.5rem;
	background-color: #fff;
	font-family: 'NotoSansKR-Regular', sans-serif;
	overscroll-behavior: contain;
`;

export const Input = styled.input`
	width: 4rem;
	height: 3rem;
	border: 1px solid #ddd;
	border-radius: 0.25rem;
	text-align: center;
	font-size: 1.4rem;
	font-weight: 600;
	color: #333;
	background-color: #fff;
	font-family: 'NotoSansKR-Bold', sans-serif;
	overscroll-behavior: contain;

	&:focus {
		outline: none;
		border-color: #ddd;
	}

	&::placeholder {
		color: #999;
		font-weight: 400;
	}
`;

export const Separator = styled.span`
	font-size: 1.5rem;
	font-weight: bold;
	color: #666;
	margin: 0 0.25rem;
`;
